"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@21st-night/core");
var CardCategorySelect_1 = __importDefault(require("../CardCategorySelect"));
var Select_1 = require("../../Select");
var CardCategorySelectContainer = function (_a) {
    var onChangeProp = _a.onChange, value = _a.value, other = __rest(_a, ["onChange", "value"]);
    var deck = core_1.useDeck();
    var categories = deck.categories;
    var categoryOptions = categories.map(function (category) { return ({
        value: category,
        label: category,
    }); });
    var _b = __read(react_1.useState(null), 2), editingOption = _b[0], setEditingOption = _b[1];
    var _c = __read(react_1.useState(''), 2), editingOptionValue = _c[0], setEditingOptionValue = _c[1];
    var onChange = react_1.useCallback(function (newValue) {
        onChangeProp(core_1.simulateChangeEvent('category', newValue));
    }, [onChangeProp]);
    var handleCreate = react_1.useCallback(function (name) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deck.addCategory(name)];
                case 1:
                    _a.sent();
                    onChange(name);
                    return [2 /*return*/];
            }
        });
    }); }, [onChange, deck]);
    var handleChange = react_1.useCallback(function (option, event) {
        if (event.action === 'create-option') {
            handleCreate(option.label);
        }
        else if (event.action === 'clear') {
            onChange(null);
        }
        else {
            onChange(option.value);
        }
    }, [onChange, handleCreate]);
    var handleClickEditOption = react_1.useCallback(function (option) {
        setEditingOption(option);
        setEditingOptionValue(option.value);
    }, []);
    var closeEditOptionDialog = react_1.useCallback(function () {
        setEditingOption(null);
    }, []);
    var handleUpdateOption = react_1.useCallback(function () {
        if (editingOption === null)
            return;
        var oldName = editingOption.value;
        deck.renameCategory(oldName, editingOptionValue);
        closeEditOptionDialog();
        if (value === oldName) {
            onChange(editingOptionValue);
        }
    }, [
        editingOption,
        onChange,
        closeEditOptionDialog,
        value,
        deck,
        editingOptionValue,
    ]);
    var handleDeleteOption = react_1.useCallback(function () {
        deck.removeCategory(editingOption.value);
        closeEditOptionDialog();
        if (value === editingOption.value) {
            onChange(null);
        }
    }, [closeEditOptionDialog, value, editingOption, onChange, deck]);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(CardCategorySelect_1.default, __assign({ editable: true, placeholder: "Add a category", options: categoryOptions, onChange: handleChange, value: categoryOptions.find(function (option) { return option.value === value; }), onClickEditOption: handleClickEditOption }, other)),
        react_1.default.createElement(Select_1.SelectEditOptionDialog, { open: !!editingOption, value: editingOptionValue, onChange: function (event) {
                return setEditingOptionValue(event.target.value);
            }, onSubmit: handleUpdateOption, onClickDelete: handleDeleteOption, onClose: closeEditOptionDialog })));
};
exports.default = CardCategorySelectContainer;
//# sourceMappingURL=CardCategorySelectContainer.js.map